import { useMutation, useQueryClient } from "@tanstack/react-query";
import productPriceHistoryApi from "../services/productPriceHistory.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  PRODUCT_PRICE_HISTORY_MESSAGES_ERROR,
  PRODUCT_PRICE_HISTORY_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableProductPriceHistory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => productPriceHistoryApi.enable(id),
    onError: (error: Error) => {
      errorNotification(PRODUCT_PRICE_HISTORY_MESSAGES_ERROR.ENABLE_ERROR);
    },
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(PRODUCT_PRICE_HISTORY_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(
        PRODUCT_PRICE_HISTORY_MESSAGES_SUCCESS.ENABLE_SUCCESS,
      );
      queryClient.invalidateQueries({
        queryKey: ["product-price-histories"],
      });
    },
  });
};

export const useDisableProductPriceHistory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => productPriceHistoryApi.disable(id),
    onError: (error: Error) => {
      errorNotification(PRODUCT_PRICE_HISTORY_MESSAGES_ERROR.DISABLE_ERROR);
    },
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(PRODUCT_PRICE_HISTORY_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(
        PRODUCT_PRICE_HISTORY_MESSAGES_SUCCESS.DISABLE_SUCCESS,
      );
      queryClient.invalidateQueries({
        queryKey: ["product-price-histories"],
      });
    },
  });
};
